import { TranslationKey } from './en';

export const es: Record<TranslationKey, string> = {
  'common.back': 'Atrás',
  'common.active': 'Activo',
  'common.inactive': 'Inactivo',
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.cancel': 'Cancelar',
  'common.ok': 'Aceptar',
  'common.confirm': 'Confirmar',
  'common.confirmTitle': 'Confirmar acción',
  'common.alertTitle': 'Aviso',
  'common.errorTitle': 'Error',
  'common.save': 'Guardar',
  'common.edit': 'Editar',
  'common.delete': 'Eliminar',
  'common.loading': 'Cargando...',
  'common.retry': 'Reintentar',
  'common.unavailable': 'No disponible',
  'common.name': 'Nombre',
  'common.slug': 'Slug',
  'common.status': 'Estado',
  'common.parent': 'Padre',
  'common.type': 'Tipo',
  'common.system': 'Sistema',
  'common.noneRoot': 'Ninguno (raíz)',
  'common.language': 'Idioma',
  'common.english': 'Inglés',
  'common.spanish': 'Español',
  'login.eyebrow': 'Aroma para cada espacio.',
  'login.hero': 'Panel de administración del catálogo Diffuser Dreams, marcas, categorías y pedidos.',
  'login.signIn': 'Acceso al Admin',
  'login.email': 'Correo',
  'login.password': 'Contraseña',
  'login.submit': 'Entrar',
  'login.error': 'Correo o contraseña inválidos.',
  'passwordReset.forgotLink': '¿Olvidaste tu contraseña?',
  'passwordReset.forgotTitle': 'Restablecer contraseña',
  'passwordReset.forgotHero': 'Ingresa tu correo y te enviaremos un enlace de restablecimiento.',
  'passwordReset.forgotHint': 'Enviaremos un enlace si existe una cuenta con ese correo.',
  'passwordReset.sendLink': 'Enviar enlace',
  'passwordReset.sent': 'Si existe una cuenta con ese correo, se ha enviado un enlace de restablecimiento.',
  'passwordReset.backToLogin': 'Volver al inicio de sesión',
  'passwordReset.requestError': 'No se pudo enviar el correo. Intenta más tarde.',
  'passwordReset.resetTitle': 'Elige una nueva contraseña',
  'passwordReset.resetHero': 'Establece una nueva contraseña para tu cuenta de admin.',
  'passwordReset.newPassword': 'Nueva contraseña',
  'passwordReset.confirmPassword': 'Confirmar contraseña',
  'passwordReset.savePassword': 'Guardar contraseña',
  'passwordReset.done': 'Contraseña actualizada. Ya puedes iniciar sesión.',
  'passwordReset.resetError': 'Enlace inválido o expirado.',
  'passwordReset.invalidLink': 'Este enlace no es válido. Solicita uno nuevo.',
  'passwordReset.requestNewLink': 'Solicitar nuevo enlace',
  'passwordReset.emailRequired': 'El correo es obligatorio.',
  'passwordReset.emailInvalid': 'Ingresa un correo válido.',
  'passwordReset.passwordRequired': 'La contraseña es obligatoria.',
  'passwordReset.passwordMin': 'La contraseña debe tener al menos 8 caracteres.',
  'passwordReset.confirmRequired': 'Confirma tu contraseña.',
  'passwordReset.passwordMismatch': 'Las contraseñas no coinciden.',
  'admin.panel': 'Panel Admin',
  'admin.logout': 'Salir',
  'admin.impersonating': 'Viendo como',
  'admin.exitImpersonation': 'Salir de impersonación',
  'admin.viewStorefront': 'Ver tienda',
  'admin.business': 'Negocio',
  'admin.nav.dashboard': 'Dashboard',
  'admin.nav.users': 'Usuarios',
  'admin.nav.orders': 'Pedidos',
  'admin.nav.products': 'Productos',
  'admin.nav.bundles': 'Bundles',
  'admin.nav.brands': 'Marcas',
  'admin.nav.categories': 'Categorías',
  'admin.nav.categoryFilters': 'Filtros de categoría',
  'admin.nav.categorySpecs': 'Tags de specs',
  'admin.nav.chat': 'Chat',
  'admin.nav.settings': 'Configuración',
  'admin.nav.aiMarketing': 'AI Marketing',
  'settings.title': 'Configuración del negocio',
  'settings.subtitle': 'Features, pagos y correo del business seleccionado. Cambia el business en el sidebar para editar otro.',
  'settings.editingBusiness': 'Editando business',
  'settings.tab.features': 'Features',
  'settings.tab.brand': 'Marca',
  'settings.tab.stripe': 'Stripe',
  'settings.tab.email': 'Email',
  'settings.tab.facebook': 'Facebook',
  'settings.features.sectionDesc': 'Activa o desactiva módulos para este negocio.',
  'settings.brand.sectionDesc': 'Nombre visible en PDFs y emails de confirmación de pedido.',
  'settings.stripe.sectionDesc': 'Claves de checkout solo de este business.',
  'settings.stripe.webhookSecretHint':
    'Se llena solo al crear un webhook abajo. También podés pegarlo a mano si lo copiaste de Stripe.',
  'settings.stripe.webhooksTitle': 'Webhooks de Stripe',
  'settings.stripe.webhooksDesc':
    'Lista los endpoints de la cuenta Stripe de este business. Creá uno con tu dominio público (CloudFront o custom) y borrá los viejos.',
  'settings.stripe.webhooksNeedSecret': 'Guardá primero la secret key de Stripe para gestionar webhooks.',
  'settings.stripe.webhookExpectedPath': 'Path esperado',
  'settings.stripe.webhookBaseUrl': 'Dominio público (base URL)',
  'settings.stripe.webhookBaseUrlRequired': 'Indicá la base URL del dominio (https://…).',
  'settings.stripe.webhookCreate': 'Crear webhook',
  'settings.stripe.webhookCreated': 'Webhook creado y secret guardado en este business.',
  'settings.stripe.webhookCreateError': 'No se pudo crear el webhook en Stripe.',
  'settings.stripe.webhookDeleteConfirm': '¿Eliminar este webhook?\n{url}',
  'settings.stripe.webhookDeleteError': 'No se pudo eliminar el webhook.',
  'settings.stripe.webhooksLoadError': 'No se pudieron cargar los webhooks de Stripe.',
  'settings.stripe.webhooksEmpty': 'No hay webhooks en esta cuenta Stripe.',
  'settings.stripe.webhookMatchesBusiness': 'Este business',
  'settings.email.sectionDesc':
    'Identidad From de Resend para este business. El dominio debe estar verificado en Resend.',
  'settings.features.liveChat': 'Chat en vivo',
  'settings.features.liveChatDesc': 'Widget para visitantes e inbox admin de este business.',
  'settings.features.aiMarketing': 'AI Marketing',
  'settings.features.aiMarketingDesc': 'Conecta Meta con OAuth, assistant de insights y creatives/ads futuros.',
  'aiMarketing.back': 'Volver a AI Marketing',
  'aiMarketing.loadError': 'No se pudo cargar AI Marketing.',
  'aiMarketing.disconnectTitle': '¿Desconectar Meta?',
  'aiMarketing.disconnectMessage': 'Se elimina la conexión Meta de este business.',
  'aiMarketing.hub.subtitle': 'Creatives, ads en pausa, posts orgánicos y el asistente — las conexiones Meta van abajo cuando las necesites.',
  'aiMarketing.hub.toolsCol': 'Herramienta',
  'aiMarketing.hub.descCol': 'Descripción',
  'aiMarketing.hub.open': 'Abrir',
  'aiMarketing.integrations.subtitle': 'Conecta Facebook Page, Instagram y cuenta publicitaria opcional en un solo inicio de sesión Meta.',
  'aiMarketing.integrations.onePerBusiness': 'Una conexión Meta por business — reconectar reemplaza la Page e Instagram actuales.',
  'aiMarketing.integrations.reconnect': 'Reconectar',
  'aiMarketing.integrations.channel': 'Canal',
  'aiMarketing.integrations.meta': 'Meta',
  'aiMarketing.integrations.metaHint': 'Inicia sesión con Meta una vez. Facebook Page es obligatoria; Instagram y cuentas publicitarias son opcionales.',
  'aiMarketing.integrations.facebook': 'Facebook Page',
  'aiMarketing.integrations.instagram': 'Instagram',
  'aiMarketing.integrations.notConnected': 'No conectado',
  'aiMarketing.hub.creativesDesc': 'Sube tu propia imagen/video o usa un producto del catálogo.',
  'aiMarketing.hub.organicDesc': 'Historial de posts orgánicos publicados (solo lectura).',
  'aiMarketing.hub.assistantDesc': 'Pregunta por reels y videos orgánicos en tus cuentas Meta conectadas.',
  'aiMarketing.nav.assistant': 'AI Assistant',
  'aiMarketing.nav.creatives': 'Creatives',
  'aiMarketing.nav.organic': 'Orgánico',
  'aiMarketing.connection.notConnected': 'Meta no está conectado en este business.',
  'aiMarketing.connection.needsSelection': 'Meta autorizado. Elige Page y Ad Account para terminar.',
  'aiMarketing.connection.connectMeta': 'Iniciar sesión con Meta',
  'aiMarketing.connection.continue': 'Continuar configuración',
  'aiMarketing.connection.disconnect': 'Desconectar',
  'aiMarketing.connect.title': 'Conectar Meta',
  'aiMarketing.connect.subtitleWizard': 'Inicia sesión con Meta y elige Page, Instagram y cuenta publicitaria opcional.',
  'aiMarketing.connect.metaFlowDesc': 'Facebook Page es obligatoria. Activa Instagram o publicidad solo si los necesitas.',
  'aiMarketing.connect.navConfigure': 'Qué conectar',
  'aiMarketing.connect.navAccounts': 'Elegir cuentas',
  'aiMarketing.connect.intentTitle': '¿Qué quieres conectar?',
  'aiMarketing.connect.intentFacebookPage': 'Facebook Page (obligatorio)',
  'aiMarketing.connect.intentInstagram': 'Cuenta de Instagram',
  'aiMarketing.connect.instagramOnThisPage': 'Vinculado a esta Page',
  'aiMarketing.connect.instagramOtherOnMeta': 'Otro Instagram en Meta',
  'aiMarketing.connect.instagramNoneForPage': 'No se encontró Instagram en Meta para este login. Conecta Instagram por separado si lo necesitas.',
  'aiMarketing.connect.permissionsTitle': 'Permisos solicitados',
  'aiMarketing.connect.scope.pagesShowList': 'Ver tus Facebook Pages',
  'aiMarketing.connect.scope.pagesReadEngagement': 'Leer engagement e insights de Pages',
  'aiMarketing.connect.scope.pagesManagePosts': 'Crear y gestionar publicaciones en tus Pages',
  'aiMarketing.connect.scope.businessManagement': 'Gestionar activos del negocio',
  'aiMarketing.connect.scope.instagramBasic': 'Ver perfil de Instagram',
  'aiMarketing.connect.scope.instagramManageInsights': 'Leer insights de Instagram',
  'aiMarketing.connect.scope.instagramContentPublish': 'Publicar contenido en Instagram',
  'aiMarketing.connect.noPages': 'No encontramos una Facebook Page que gestiones. Créala y luego refresca.',
  'aiMarketing.connect.overwriteTitle': '¿Reemplazar Instagram?',
  'aiMarketing.connect.overwriteMessage': 'Este business ya usa {username}. Solo se permite un Instagram — la nueva conexión lo reemplazará.',
  'aiMarketing.connect.overwritePageTitle': '¿Reemplazar Facebook Page?',
  'aiMarketing.connect.overwritePageMessage': 'Este business ya usa {name}. Solo se permite una Page — la nueva conexión la reemplazará.',
  'aiMarketing.connect.createPage': 'Crear Facebook Page',
  'aiMarketing.connect.refresh': 'Refrescar Pages',
  'aiMarketing.connect.page': 'Facebook Page',
  'aiMarketing.connect.instagram': 'Instagram',
  'aiMarketing.connect.instagramOptional': 'Opcional — ninguno',
  'aiMarketing.connect.selectRequired': 'Selecciona una Facebook Page para continuar. Ad Account es opcional hasta habilitar scopes de Marketing API.',
  'aiMarketing.assistant.subtitle':
    'Pregunta por reels y videos orgánicos en tu Facebook Page e Instagram conectados.',
  'aiMarketing.assistant.empty': 'Prueba preguntar qué reel tuvo más vistas o cuál fue el último publicado.',
  'aiMarketing.assistant.placeholder': 'Pregunta lo que quieras sobre tu marketing Meta…',
  'aiMarketing.assistant.launcher': 'AI Assistant',
  'aiMarketing.assistant.send': 'Enviar',
  'aiMarketing.assistant.platform': 'Plataforma',
  'aiMarketing.assistant.views': 'Vistas',
  'aiMarketing.assistant.reach': 'Alcance',
  'aiMarketing.assistant.posted': 'Publicado',
  'aiMarketing.assistant.content': 'Contenido',
  'aiMarketing.assistant.thinking': 'Pensando…',
  'aiMarketing.creatives.subtitle': 'Sube tu imagen/video o usa un producto del catálogo, luego aprueba antes de usar.',
  'aiMarketing.creatives.uploadTitle': 'Subir tu asset',
  'aiMarketing.creatives.uploadHint': 'JPG/PNG/WebP hasta 20MB, o MP4 hasta 100MB.',
  'aiMarketing.creatives.upload': 'Subir',
  'aiMarketing.creatives.add': 'Añadir',
  'aiMarketing.creatives.addClose': 'Cerrar',
  'aiMarketing.creatives.fromProductTitle': 'Desde producto del catálogo',
  'aiMarketing.creatives.fromProductHint': 'Busca un producto y usa su imagen como creative — sin archivo en tu PC.',
  'aiMarketing.creatives.fromProductSearch': 'Buscar producto',
  'aiMarketing.creatives.fromProductSearchPlaceholder': 'Nombre, SKU o modelo…',
  'aiMarketing.creatives.fromProductCreate': 'Crear creative',
  'aiMarketing.creatives.fromProductCancel': 'Elegir otro',
  'aiMarketing.creatives.publish': 'Publicar',
  'aiMarketing.creatives.publishing': 'Publicando…',
  'aiMarketing.creatives.publishingTo': 'Publicando en {platform}…',
  'aiMarketing.creatives.publishingHint': 'Puede tardar hasta un minuto, sobre todo con videos.',
  'aiMarketing.creatives.publishCaption': 'Caption',
  'aiMarketing.creatives.publishCancel': 'Volver',
  'aiMarketing.creatives.publishPlatformsEmpty':
    'No hay destinos conectados. Conecta Facebook o Instagram en integraciones de AI Marketing.',
  'aiMarketing.creatives.publishConfirmTitle': '¿Publicar creative?',
  'aiMarketing.creatives.publishConfirmMessage': 'Publicar en: {destinations}.',
  'aiMarketing.creatives.publishPartialTitle': 'Algunos destinos fallaron',
  'aiMarketing.platform.Facebook': 'Facebook',
  'aiMarketing.platform.Instagram': 'Instagram',
  'aiMarketing.creatives.library': 'Biblioteca',
  'aiMarketing.creatives.empty': 'Aún no hay creatives. Sube un asset o crea uno desde un producto.',
  'aiMarketing.creatives.allStatuses': 'Todos los estados',
  'aiMarketing.creatives.allTypes': 'Todos los tipos',
  'aiMarketing.creatives.allSources': 'Todos los orígenes',
  'aiMarketing.creatives.approve': 'Aprobar',
  'aiMarketing.creatives.deleteTitle': '¿Eliminar creative?',
  'aiMarketing.creatives.deleteMessage':
    'Se elimina el creative permanentemente. Los posts publicados siguen en Orgánico.',
  'aiMarketing.creatives.publishedOn': 'Publicado en',
  'aiMarketing.creatives.status.Generated': 'Generado',
  'aiMarketing.creatives.status.Approved': 'Aprobado',
  'aiMarketing.creatives.source.UserUpload': 'Subida',
  'aiMarketing.creatives.source.ProductCatalog': 'Producto',
  'aiMarketing.creatives.type.Image': 'Imagen',
  'aiMarketing.creatives.type.Video': 'Video',

  'aiMarketing.organic.subtitle': 'Historial de posts orgánicos publicados desde creatives (solo lectura).',
  'aiMarketing.organic.viewPost': 'Ver post',
  'aiMarketing.organic.empty': 'Aún no hay posts orgánicos. Publica desde Creatives.',
  'aiMarketing.organic.status.Draft': 'Borrador',
  'aiMarketing.organic.status.Approved': 'Aprobado',
  'aiMarketing.organic.status.Published': 'Publicado',
  'aiMarketing.organic.status.Failed': 'Fallido',
  'settings.brand.displayName': 'Nombre visible',
  'settings.stripe.publishableKey': 'Publishable key',
  'settings.stripe.secretKey': 'Secret key',
  'settings.stripe.webhookSecret': 'Webhook secret',
  'settings.email.domain': 'Dominio de email',
  'settings.email.orderUserName': 'Usuario pedidos',
  'settings.email.orderFromName': 'From pedidos',
  'settings.email.passwordResetUserName': 'Usuario reset password',
  'settings.email.passwordResetFromName': 'From reset password',
  'settings.email.test': 'Probar email',
  'settings.email.testing': 'Enviando…',
  'settings.email.testSent': 'Email de prueba enviado a {to} desde {from}.',
  'settings.email.testError': 'No se pudo enviar el email de prueba.',
  'settings.facebook.sectionDesc':
    'Credenciales Meta de este business (Facebook Login y OAuth de AI Marketing).',
  'settings.facebook.appId': 'Facebook App ID',
  'settings.facebook.appSecret': 'Facebook App secret',
  'settings.secretPlaceholder': 'Dejar en blanco para no cambiar',
  'settings.saved': 'Configuración guardada.',
  'settings.loadError': 'No se pudo cargar la configuración.',
  'settings.saveError': 'No se pudo guardar la configuración.',
  'chat.send': 'Enviar',
  'chat.close': 'Cerrar',
  'chat.mute': 'Silenciar sonido',
  'chat.unmute': 'Activar sonido',
  'chat.visitor.launcher': 'Chatea con nosotros',
  'chat.visitor.title': 'Chat en vivo',
  'chat.visitor.empty': 'Haz una pregunta y nuestro equipo responderá aquí.',
  'chat.visitor.greeting':
    '¡Hola! ¿Cómo podemos ayudarte hoy? Cuéntanos qué necesitas y nuestro equipo te responderá en breve.',
  'chat.visitor.placeholder': 'Escribe tu mensaje…',
  'chat.admin.subtitle': 'Conversaciones de visitantes de este negocio.',
  'chat.admin.empty': 'Aún no hay conversaciones.',
  'chat.admin.pick': 'Selecciona una conversación para responder.',
  'chat.admin.placeholder': 'Responder al visitante…',
  'chat.admin.noPreview': 'Sin mensajes aún',
  'chat.admin.notify': 'Notificaciones de chat',
  'dashboard.subtitle': 'Accesos rápidos al catálogo administrativo.',
  'dashboard.users.title': 'Usuarios',
  'dashboard.users.desc': 'Crear y gestionar cuentas de administración',
  'dashboard.settings.title': 'Configuración',
  'dashboard.settings.desc': 'Features, Stripe y SMTP de este business',
  'dashboard.orders.title': 'Pedidos',
  'dashboard.orders.desc': 'Ver checkouts guest y estado de pago',
  'dashboard.products.title': 'Productos',
  'dashboard.products.desc': 'Gestiona productos HVAC y precios',
  'dashboard.bundles.title': 'Bundles',
  'dashboard.bundles.desc': 'Gestiona paquetes de sistema y opcionales',
  'dashboard.brands.title': 'Marcas',
  'dashboard.brands.desc': 'Gestiona marcas del catálogo',
  'dashboard.categories.title': 'Categorías',
  'dashboard.categories.desc': 'Árbol de 2 niveles',
  'dashboard.filters.title': 'Filtros de categoría',
  'dashboard.filters.desc': 'Asigna filtros por categoría',
  'dashboard.specs.title': 'Tags de specs',
  'dashboard.specs.desc': 'Gestiona tags de especificación por categoría',
  'users.subtitle': 'Cuentas de administración de la plataforma.',
  'users.new': 'Nuevo usuario',
  'users.edit': 'Editar usuario',
  'users.empty': 'Aún no hay usuarios.',
  'users.email': 'Correo',
  'users.emailRequired': 'El correo es obligatorio.',
  'users.emailInvalid': 'Introduce un correo válido.',
  'users.password': 'Contraseña',
  'users.passwordMin': 'La contraseña debe tener al menos 8 caracteres.',
  'users.passwordRequired': 'La contraseña es obligatoria.',
  'users.role': 'Rol',
  'users.scope': 'Alcance',
  'users.business': 'Negocio',
  'users.selectBusiness': 'Selecciona negocio',
  'users.loadError': 'No se pudieron cargar los usuarios.',
  'users.saveError': 'No se pudo guardar el usuario.',
  'users.impersonate': 'Entrar como',
  'users.impersonateError': 'No se pudo impersonar ese usuario.',
  'users.role.PortalAdmin': 'Admin portal',
  'users.role.BusinessAdmin': 'Admin de negocio',
  'brands.subtitle': 'CRUD de marcas del sistema',
  'brands.new': 'Nueva marca',
  'brands.edit': 'Editar marca',
  'brands.empty': 'No hay marcas.',
  'brands.loadError': 'No se pudieron cargar las marcas.',
  'brands.saveError': 'No se pudo guardar la marca.',
  'brands.deleteError': 'No se pudo eliminar la marca.',
  'brands.deleteConfirm': '¿Eliminar marca "{name}"?',
  'brands.logo': 'Logo',
  'brands.logoOptional': '(opcional)',
  'brands.logoHint': 'Opcional. PNG, JPG, WebP, GIF o SVG. Si tiene imagen, se muestra en Shop By Brand junto al nombre; si no, solo el texto.',
  'brands.chooseLogo': 'Elegir logo',
  'brands.removeLogo': 'Quitar logo',
  'categories.subtitle': 'Padres e hijas (máximo 2 niveles)',
  'categories.new': 'Nueva categoría',
  'categories.edit': 'Editar categoría',
  'categories.addChild': '+ Hija',
  'categories.empty': 'No hay categorías.',
  'categories.loadError': 'No se pudieron cargar las categorías.',
  'categories.saveError': 'No se pudo guardar la categoría.',
  'categories.deleteError': 'No se pudo eliminar la categoría.',
  'categories.deleteConfirm': '¿Eliminar categoría "{name}"?',
  'categories.order': 'Orden',
  'categories.saveOrder': 'Guardar orden',
  'categories.moveUp': 'Subir',
  'categories.moveDown': 'Bajar',
  'categories.orderError': 'No se pudo guardar el orden de categorías.',
  'categories.image': 'Imagen',
  'categories.imageOptional': '(opcional)',
  'categories.imageHint': 'Opcional. PNG, JPG, WebP, GIF o SVG. Se muestra en las tarjetas de categoría de la página de inicio.',
  'categories.chooseImage': 'Elegir imagen',
  'categories.removeImage': 'Quitar imagen',
  'filters.subtitle': 'Define filtros y asígnalos a categorías hoja',
  'filters.new': 'Nuevo filtro',
  'filters.edit': 'Editar filtro',
  'filters.leafCategory': 'Categorías hijas',
  'filters.noLeaf': 'No hay categorías hija.',
  'filters.assigned': 'Asignados',
  'filters.noneAssigned': 'Sin filtros asignados.',
  'filters.available': 'Disponibles para asignar',
  'filters.noneAvailable': 'No hay filtros disponibles.',
  'filters.remove': 'Quitar',
  'filters.assign': 'Asignar',
  'filters.catalog': 'Catálogo de filtros',
  'filters.valueType': 'Tipo de valor',
  'filters.options': 'Opciones',
  'filters.addOption': 'Agregar opción',
  'filters.optionsHint': 'Define los valores seleccionables. En el catálogo se muestran como checkboxes multi-selección.',
  'filters.optionLabel': 'Etiqueta',
  'filters.optionValue': 'Valor (slug opcional)',
  'filters.optionsRequired': 'Agrega al menos una opción para filtros Options.',
  'filters.saveOrder': 'Guardar orden',
  'filters.moveUp': 'Subir',
  'filters.moveDown': 'Bajar',
  'filters.orderError': 'No se pudo guardar el orden de los filtros.',
  'filters.loadCategoriesError': 'No se pudieron cargar categorías.',
  'filters.loadError': 'No se pudieron cargar filtros.',
  'filters.loadCategoryError': 'No se pudieron cargar filtros de categoría.',
  'filters.assignError': 'No se pudo asignar el filtro.',
  'filters.unassignError': 'No se pudo quitar el filtro.',
  'filters.unassignConfirmSimple': '¿Quitar el filtro "{name}" de esta categoría?',
  'filters.unassignConfirmUsed':
    'El filtro "{name}" está en uso. Al quitarlo también se eliminarán:\n• {values} valor(es) permitidos de la categoría\n• el atributo en {products} producto(s)\n• el atributo en {bundles} bundle(s)\n\n¿Continuar?',
  'filters.createError': 'No se pudo crear el filtro.',
  'filters.updateError': 'No se pudo actualizar el filtro.',
  'filters.deleteError': 'No se pudo eliminar el filtro.',
  'filters.systemDeleteError': 'Los filtros de sistema no se pueden eliminar.',
  'filters.deleteConfirm': '¿Eliminar filtro "{name}"?',
  'products.subtitle': 'CRUD del catálogo de productos',
  'products.new': 'Nuevo producto',
  'products.edit': 'Editar producto',
  'products.empty': 'No hay productos.',
  'products.price': 'Precio',
  'products.compareAtPrice': 'Precio comparado',
  'products.variants': 'Variantes',
  'products.variant': 'Variante',
  'products.defaultVariant': 'Por defecto',
  'products.variantsHint': 'Solo una opción (ej. Tamaño). Agrega cada variante con valor, SKU, precio y compare-at.',
  'products.optionName': 'Nombre de opción',
  'products.optionNamePlaceholder': 'ej. Tamaño',
  'products.optionNameRequired': 'Indica el nombre de la opción antes de agregar variantes (ej. Tamaño).',
  'products.optionValue': 'Valor',
  'products.optionValuePlaceholder': 'ej. 50ml',
  'products.addVariant': 'Agregar variante',
  'products.addVariantHint': 'Completa todos los campos y agrega. Las filas existentes se editan abajo.',
  'products.duplicateOptionValue': 'Ese valor de opción ya existe.',
  'products.compareAtInvalid': 'El compare-at debe ser mayor que el precio.',
  'products.variantsIncomplete': 'Completa valor, SKU y precio de la variante.',
  'products.category': 'Categoría',
  'products.description': 'Descripción',
  'products.descriptionHint': 'Se admite HTML (ej. <p>, <ul>, <strong>).',
  'products.loadError': 'No se pudieron cargar los productos.',
  'products.saveError': 'No se pudo guardar el producto.',
  'products.deleteError': 'No se pudo eliminar el producto.',
  'products.deleteConfirm': '¿Eliminar producto "{name}"?',
  'products.attributes': 'Filtros de categoría',
  'products.noAttributes': 'Esta categoría no tiene filtros personalizados asignados.',
  'products.attributesHint': 'Marca y precio usan los campos de arriba. Aquí aparecen el resto de filtros asignados.',
  'products.specifications': 'Especificaciones del producto',
  'products.specificationsHint': 'Elige un tag existente o escribe uno nuevo (se crea automáticamente para esta categoría).',
  'products.addSpec': 'Agregar fila',
  'products.noSpecs': 'Sin especificaciones.',
  'products.specTag': 'Tag',
  'products.specValue': 'Valor',
  'products.images': 'Imágenes',
  'products.imagesHint': 'Sube una o más imágenes. La primera queda como principal.',
  'products.noImages': 'Sin imágenes.',
  'products.setPrimary': 'Hacer principal',
  'products.primary': 'Principal',
  'products.documents': 'Documentos relacionados',
  'products.documentsHint': 'Elige un archivo (el título se precarga; puedes editarlo) y luego súbelo.',
  'products.chooseImages': 'Elegir imágenes',
  'products.chooseFile': 'Elegir archivo',
  'products.documentTitle': 'Título del documento',
  'products.uploadDocument': 'Subir',
  'products.selectedFile': 'Archivo seleccionado',
  'products.noDocuments': 'Sin documentos.',
  'products.saveBeforeMedia': 'Guarda el producto primero para subir imágenes y documentos.',
  'products.mediaError': 'No se pudo actualizar el media.',
  'bundles.subtitle': 'Paquetes de sistema con productos requeridos y opcionales',
  'bundles.new': 'Nuevo bundle',
  'bundles.edit': 'Editar bundle',
  'bundles.empty': 'No hay bundles.',
  'bundles.loadError': 'No se pudieron cargar los bundles.',
  'bundles.saveError': 'No se pudo guardar el bundle.',
  'bundles.deleteError': 'No se pudo eliminar el bundle.',
  'bundles.deleteConfirm': '¿Eliminar bundle "{name}"?',
  'bundles.requiredProductsError': 'Agrega al menos un producto requerido.',
  'bundles.packProducts': 'Productos del pack',
  'bundles.packProductsHint': 'Los requeridos siempre van incluidos. Los opcionales se pueden sumar al comprar.',
  'bundles.searchProducts': 'Buscar productos',
  'bundles.searchProductsPlaceholder': 'Nombre, SKU o modelo...',
  'bundles.noProductResults': 'No hay productos activos que coincidan.',
  'bundles.addRequired': '+ Requerido',
  'bundles.addOptional': '+ Opcional',
  'bundles.required': 'Requeridos',
  'bundles.optional': 'Opcionales',
  'bundles.noRequired': 'Sin productos requeridos.',
  'bundles.noOptional': 'Sin productos opcionales.',
  'bundles.makeOptional': 'Hacer opcional',
  'bundles.makeRequired': 'Hacer requerido',
  'specs.subtitle': 'Define tags reutilizables por categoría de producto',
  'specs.leafCategory': 'Categoría hoja',
  'specs.noLeaf': 'No hay categorías hija.',
  'specs.catalog': 'Tags de la categoría',
  'specs.new': 'Nuevo tag',
  'specs.edit': 'Editar tag',
  'specs.empty': 'No hay tags para esta categoría.',
  'specs.loadCategoriesError': 'No se pudieron cargar categorías.',
  'specs.loadError': 'No se pudieron cargar los tags.',
  'specs.saveError': 'No se pudo guardar el tag.',
  'specs.deleteError': 'No se pudo eliminar el tag.',
  'specs.deleteConfirm': '¿Eliminar tag "{name}"?',
  'specs.saveOrder': 'Guardar orden',
  'specs.moveUp': 'Subir',
  'specs.moveDown': 'Bajar',
  'specs.orderError': 'No se pudo guardar el orden de tags.',
  'portal.model': 'Modelo',
  'portal.catalog.brand': 'Marca',
  'portal.catalog.allBrands': 'Todas las marcas',
  'portal.catalog.allCategories': 'Todas las categorías',
  'portal.product.quantity': 'Cantidad',
  'portal.checkout.pdfError': 'No se pudo descargar el PDF.',
  'orders.subtitle': 'Checkouts guest y estado de pago.',
  'orders.empty': 'No hay pedidos.',
  'orders.loadError': 'No se pudieron cargar los pedidos.',
  'orders.searchPlaceholder': 'Buscar correo, nombre, teléfono, id…',
  'orders.filter': 'Filtrar',
  'orders.created': 'Creado',
  'orders.paid': 'Pagado',
  'orders.customer': 'Cliente',
  'orders.email': 'Correo',
  'orders.total': 'Total',
  'orders.subtotal': 'Subtotal',
  'orders.tax': 'Impuesto (7%)',
  'orders.lines': 'Líneas',
  'orders.view': 'Ver',
  'orders.detail': 'Detalle del pedido',
  'orders.orderId': 'Pedido #',
  'orders.lineItems': 'Líneas',
  'orders.item': 'Ítem',
  'orders.type': 'Tipo',
  'orders.price': 'Precio',
  'orders.lineTotal': 'Total línea',
  'orders.downloadPdf': 'Descargar PDF',
  'orders.pdf': 'PDF',
  'orders.showing': 'Mostrando {shown} de {total} pedidos.',
  'orders.status.Pending': 'Pendiente',
  'orders.status.Paid': 'Pagado',
  'common.close': 'Cerrar'
};
